import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';

const NewRecipe = () => {

    const [name, setName] = useState("");
    const [ingredients, setIngredients] = useState("");
    const [description, setDescription] = useState("");

    const history = useHistory();

    const saveRecipe = async (e) => {

        if(name === "") 
        return alert("name cannot be empty");

        if(ingredients === "") 
        return alert("ingredients cannot be empty");

        if(description === "") 
        return alert("description cannot be empty");

        e.preventDefault();
        const data = {
            name: name,
            ingredients: ingredients,
            description: description
        }
        const newRecipe = await fetch('https://recipe-app-backend-ionut.herokuapp.com/recipes', {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            }, body: JSON.stringify(data)
            })
        const response = newRecipe.json();
        console.log(response.data);

        history.push("");

        setName("");
        setIngredients("");
        setDescription("");
    }


    return (
        <div className="new-recipe">
            <h2>Add new recipe:</h2>
             <p>Name: </p>
            <input 
                type="text" 
                id="name" 
                placeholder="Recipe name" 
                value={name} onChange={(e) => setName(e.target.value)}
            />
            
            <p>Ingredients: </p>
            <input 
                type="text" 
                id="ingredients" 
                placeholder="Ingredients" 
                value={ingredients} 
                onChange={(e) => setIngredients(e.target.value)}
            />
            
            <p>How to make it: </p>
            <textarea 
                type="text" 
                id="description" 
                placeholder="How to make it" 
                value={description} onChange={(e) => setDescription(e.target.value)} 
            />
           
            <Button
                className="save-recipe-button"
                onClick={saveRecipe}
                startIcon={<PlaylistAddCheckIcon />}>
                Save
            </Button>
        
        </div>
    )
}

export default NewRecipe;
